<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props', 'reset-select-product')">
                        </b-tab>
                        <b-tab title="Bank" :active="showRefinancingBank"  @click="emitEvent('show-refinancing-bank')">
                            <RefinancingBankSelection />
                        </b-tab>
                        <b-tab title="Refinance" :active="showRefinancingSelection"  @click="emitEvent('show-refinancing-selection')">
                            <RefinancingSelection />
                        </b-tab>
                        <b-tab title="Summary" :active="showRefinancingSummary" @click="emitEvent('show-refinancing-summary')">
                            <RefinancingSummary :is_active="showRefinancingSummary" />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import RefinancingBankSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/RefinancingSolution/RefinancingBankSelection'
import RefinancingSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/RefinancingSolution/RefinancingSelection.vue'
import RefinancingSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/RefinancingSolution/RefinancingSummary.vue'

export default {
    props: {
        showRefinancingBank: Boolean,
        showRefinancingSelection: Boolean,
        showRefinancingSummary: Boolean,
        // showInsuranceSummary: Boolean,
    },
    components: {
        RefinancingBankSelection,
        RefinancingSelection,
        RefinancingSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    methods: {
        emitEvent(...eventNames) {
            eventNames.forEach(eventName => {
                solutionEventBus.$emit(eventName)
            })
        }
    },
}
</script>